import "./home.page.scss";
import HomeMainComp from "../../components/home-main-comp/home-main.comp";
import { HOME_MAIN_COMP_DATA } from "../../data/pages/home/home.data";
import { useResponsive } from "../../hooks/responsive.hook";
import SmallHomePage from "./small-home.page";
import { useContext } from "react";
import { LanguageContext } from "../../contexts/language/language.context";

const Home = () => {
  const { l } = useContext(LanguageContext);
  let data = HOME_MAIN_COMP_DATA.en;
  if (l.code === "fr") {
    data = HOME_MAIN_COMP_DATA.fr;
  } else if (l.code === "en") {
    data = HOME_MAIN_COMP_DATA.en;
  }
  const homeData = data;
  const { currentScreen } = useResponsive();
  return (
    <div className="home-container">
      {homeData.map((hD) =>
        currentScreen.size !== "small" ? (
          <HomeMainComp
            homeMainCompData={hD.homeMainCompData}
            key={hD.homeMainCompData.label}
          ></HomeMainComp>
        ) : (
          <SmallHomePage homeMainCompData={hD.homeMainCompData} />
        )
      )}
    </div>
  );
};

export default Home;
